"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_common_1 = require("@progress/kendo-react-common");
var utils_1 = require("./utils");
var preventDefault = function (e) { return e.preventDefault(); };
/**
 * @hidden
 */
var ListDefaultItem = /** @class */ (function (_super) {
    __extends(ListDefaultItem, _super);
    function ListDefaultItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListDefaultItem.prototype.render = function () {
        var _a = this.props, selected = _a.selected, defaultItem = _a.defaultItem, textField = _a.textField;
        return (React.createElement("div", { onClick: this.props.onClick, onMouseDown: preventDefault, className: kendo_react_common_1.classNames('k-list-optionlabel', {
                'k-state-selected': selected
            }) }, utils_1.getItemValue(defaultItem, textField) || ''));
    };
    return ListDefaultItem;
}(React.Component));
exports.default = ListDefaultItem;
//# sourceMappingURL=ListDefaultItem.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dropdowns@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_re_vkmwb4tr3wvnf7qdjhi25kjvza/~/@progress/kendo-react-dropdowns/dist/npm/common/ListDefaultItem.js
// module id = 6545
// module chunks = 0